<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="toolbar">
        <h2>{{ $t('RFM 客户模型') }}</h2>
        <a-radio-group v-model="recencyRange" button-style="solid" @change="loadData">
          <a-radio-button value="">{{ $t('全部') }}</a-radio-button>
          <a-radio-button value="7">{{ $t('7天内') }}</a-radio-button>
          <a-radio-button value="30">{{ $t('8-30天') }}</a-radio-button>
          <a-radio-button value="60">{{ $t('31-60天') }}</a-radio-button>
          <a-radio-button value="120">{{ $t('61-120天') }}</a-radio-button>
          <a-radio-button value="120+">{{ $t('120天以上') }}</a-radio-button>
        </a-radio-group>
      </div>
      <a-spin :spinning="loading">
        <a-row :gutter="16">
          <a-col
            v-for="item in groups"
            :key="item.rfmGroup"
            :xs="24"
            :sm="12"
            :md="8"
            :lg="6"
            :xl="4">
            <a-card class="group-card" hoverable @click="openDetail(item.rfmGroup)">
              <a-statistic :title="groupLabel(item.rfmGroup)" :value="item.newCustomerRecords || 0" :suffix="$t('人')" />
              <div class="group-meta">{{ $t('占比') }} {{ item.percentOfCustomers || 0 }}%</div>
            </a-card>
          </a-col>
        </a-row>
        <a-table row-key="rfmGroup" :columns="columns" :data-source="groups" :pagination="false" :custom-row="customRow" />
      </a-spin>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { getRfmGroupStatistics } from '@/api/statistics/order'

const groupLabels = {
  Champions: 'Champions（超级用户）',
  Loyal: 'Loyal Customers（忠诚用户）',
  Active: 'Active（高潜忠诚）',
  New: 'New Customers（新客）',
  Promising: 'Promising（有希望用户）',
  'Needs attention': 'Need Attention（需要关注）',
  'Almost lost': 'Almost Lost（即将沉睡）',
  'At risk': 'At Risk（流失风险）',
  'Previously loyal': 'Previously Loyal（曾经的忠诚用户）',
  Dormant: 'Dormant（休眠）'
}

export default {
  name: 'RfmModel',
  data () {
    return {
      loading: false,
      recencyRange: '',
      list: [],
      columns: [
        { title: this.$t('客户分群'), dataIndex: 'rfmGroup', customRender: text => this.groupLabel(text) },
        { title: this.$t('客户占比(%)'), dataIndex: 'percentOfCustomers' },
        { title: this.$t('客户数'), dataIndex: 'newCustomerRecords' },
        { title: this.$t('平均距最近购买(天)'), dataIndex: 'daysSinceLastOrder' },
        { title: this.$t('订单数'), dataIndex: 'totalNumberOfOrders' },
        { title: this.$t('消费金额'), dataIndex: 'totalAmountSpent' }
      ]
    }
  },
  computed: {
    groups () { return this.list.filter(item => item.rfmGroup !== 'Summary') }
  },
  created () { this.loadData() },
  methods: {
    loadData () {
      this.loading = true
      getRfmGroupStatistics({ recencyRange: this.recencyRange }).then(response => {
        this.list = response.data || []
      }).finally(() => { this.loading = false })
    },
    openDetail (rfmGroup) {
      this.$router.push({ path: '/dashboard/rfm/detail', query: { rfmGroup, recencyRange: this.recencyRange } })
    },
    groupLabel (rfmGroup) { return groupLabels[rfmGroup] ? this.$t(groupLabels[rfmGroup]) : rfmGroup },
    customRow (record) {
      return { on: { click: () => this.openDetail(record.rfmGroup) } }
    }
  }
}
</script>

<style scoped>
.toolbar { display:flex; justify-content:space-between; align-items:center; margin-bottom:20px; }
.group-card { margin-bottom:16px; cursor:pointer; }
.group-meta { margin-top:8px; color:#8c8c8c; }
/deep/ .ant-table-tbody > tr { cursor:pointer; }
</style>
